export const SCHEMA_VERSION = '1.9.0';
